<script setup>
import { computed } from "vue";
import { useTriviaStore } from "@stores/trivia";
import IconImage from "@components/icons/Image.vue";
import IconMinimize from "@components/icons/Minimize.vue";

const triviaStore = useTriviaStore();

const visible = computed(() => {
    if (triviaStore.gameState === "results") return false;
    if (triviaStore.hasCorrectGuess) return false;
    if (!triviaStore.photoExpanded) return false;
    return triviaStore.photoPosition === "docked";
});
</script>

<template>
    <Transition name="fade" appear>
        <div
            v-if="visible"
            class="photo--center border-marine-500 bg-marine-800 relative flex flex-col overflow-hidden border"
        >
        <div class="bg-marine-300 relative w-full grow">
            <img
                v-if="triviaStore.currentQuestionImage"
                :src="triviaStore.currentQuestionImage"
                alt=""
                class="absolute inset-0 size-full object-cover"
                @error="$event.target.style.display = 'none'"
            />
            <button
                class="border-marine-600 shadow-marine-600 absolute top-2 right-2 flex size-8 items-center justify-center rounded-[4px] border-2 bg-yellow-400 shadow-[0_4px_0]"
                aria-label="Minimize photo"
                @click="triviaStore.togglePhotoExpanded()"
            >
                <IconMinimize class="text-marine-800 size-4" />
            </button>
        </div>
        <div
            class="bg-marine-600 body-sm flex min-h-11 items-center justify-start gap-2 px-4 font-bold uppercase"
        >
            <IconImage class="size-4" />
            <p>Where was this photo taken?</p>
        </div>
    </div>
    </Transition>
</template>

<style scoped>
.photo--center {
    grid-column: 6 / -6;
    grid-row: 2 / -4;
    z-index: 4;
}

@media (max-width: 1024px) {
    .photo--center {
        grid-column: 1 / -1;
        grid-row: 2 / -2;
        align-self: start;
        height: calc(50svh - var(--cell-y));
    }
}
</style>
